import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";

// const useStyles = makeStyles((theme) => ({
//   backdrop: {
//     zIndex: theme.zIndex.drawer + 1,
//     color: "#fff",
//   },
//   closeIcon: {
//     color: "#fff",
//     float: "right",
//     margin: "-8px",
//   },
// }));

export default function CustomPageLoading() {
  // const classes = useStyles();

  return (
    <Backdrop
      sx={{ zIndex: "99" }}
      // className={classes.backdrop}
      open={true}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
